import { ReactNode, useEffect, useState } from 'react';
import { overrideUserAgent } from '../util/user-agent';
import { KioskKeyboardProvider } from './kiosk-keyboard-provider';

export interface KioskManagerProps {
  enabled: boolean;
  children?: ReactNode;
}

const desiredUserAgent =
  'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36';

const KioskManager = (props: KioskManagerProps) => {
  const { children, enabled } = props;

  // Just because we are in kiosk mode doesn't mean we want the kiosk keyboard.
  // Currently, we only enable the kiosk keyboard if we know we are running in
  // PolyScope X (PSX) > 10.7 based on the user agent detection.
  const [isKioskKeyboardEnabled, setIsKioskKeyboardEnabled] = useState(false);

  useEffect(() => {
    const originalUserAgent = navigator?.userAgent;

    if (enabled) {
      // In PSX 10.7 the user agent has been changed from the browser default
      // and is set to TeachPendant/Universal Robots Teach Pendant/1.0. This
      // ends up breaking Intercom since it leverages user agent detection
      // to add the Intercom object to the window. Without changing the agent
      // then window.Intercom is undefined and Beacon will fail to load
      if (originalUserAgent.includes('Universal Robots Teach Pendant')) {
        overrideUserAgent(desiredUserAgent);
        setIsKioskKeyboardEnabled(true);
      }
    }

    return () => {
      if (enabled) {
        overrideUserAgent(originalUserAgent);
        setIsKioskKeyboardEnabled(false);
      }
    };
  }, [enabled]);

  return (
    <KioskKeyboardProvider enabled={isKioskKeyboardEnabled}>
      {children}
    </KioskKeyboardProvider>
  );
};

export { KioskManager };
